/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
import { isRtl as r } from "./utils/index.mjs";
import { tableKeyboardNavigationHeaderAttributes as s } from "../navigation/constants.mjs";
class a extends t.Component {
  constructor() {
    super(...arguments), this.element = null;
  }
  componentDidMount() {
    const { columnResize: e } = this.props;
    e && e.resizable && e.setIsRtl(r(this.element));
  }
  render() {
    return /* @__PURE__ */ t.createElement(
      "thead",
      {
        className: "k-table-thead k-grid-header",
        role: "presentation",
        ref: (e) => this.element = e,
        ...s
      },
      this.props.headerRow,
      this.props.filterRow
    );
  }
}
export {
  a as Header
};
